module.exports = __webpack_public_path__ + "img/flex_time.2842fbc.webp";